import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Search } from 'lucide-react';
import { useRpc } from '../../lib/queries';
import type { InboxItem } from '../../lib/classes';
import { LogoMark, Wordmark } from '../ui/Logo';
import { RefreshButton } from './TopStrip';

const ICON = 'relative inline-flex items-center justify-center w-11 h-11 rounded-md text-stone-600 active:bg-stone-100';

/** The top bar below 1024px: menu, logo, user search, refresh. */
export const MobileBar: React.FC<{ onOpenMenu: () => void; onOpenPalette: () => void }> = ({ onOpenMenu, onOpenPalette }) => {
  const { data: inbox } = useRpc<InboxItem[]>('admin_inbox', {}, { refetchInterval: 120_000 });
  const urgent = (inbox ?? []).filter(i => i.severity !== 'info');
  const hasAct = urgent.some(i => i.severity === 'act');

  return (
    <header className="lg:hidden shrink-0 z-30 bg-white border-b border-stone-200 pt-[env(safe-area-inset-top)] pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)]">
      <div className="h-12 flex items-center gap-1 px-1.5">
        <button type="button" onClick={onOpenMenu} aria-label={urgent.length ? `Open menu, ${urgent.length} inbox items need attention` : 'Open menu'} className={ICON}>
          <Menu className="w-5 h-5" />
          {urgent.length > 0 && <span className={`absolute top-2.5 right-2.5 w-2 h-2 rounded-full ring-2 ring-white ${hasAct ? 'bg-rose-500' : 'bg-amber-500'}`} />}
        </button>
        <Link to="/" aria-label="Overview" className="tap flex items-center gap-2 px-1">
          <LogoMark className="w-5 h-5" />
          <Wordmark />
        </Link>
        <div className="flex-1" />
        <button type="button" onClick={onOpenPalette} aria-label="Search users and pages" className={ICON}>
          <Search className="w-5 h-5" />
        </button>
        <RefreshButton className={ICON} iconClassName="w-5 h-5" />
      </div>
    </header>
  );
};
